import { render, staticRenderFns } from "./LaRemarks.vue?vue&type=template&id=1f82c97b"
import script from "./LaRemarks.vue?vue&type=script&lang=js"
export * from "./LaRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports